import React, { Component } from "react";
import { connect } from "react-redux";
import getUser from "../../actions/get-user";
import Header from './index';

export class HeaderContainer extends Component {
  constructor() {
    super();
  }

  componentDidMount() {
    const { getUser } = this.props;

    getUser();
  }

  render() {
    const { logged_in, username } = this.props.user;

    const userFiltered = {
      isLoggedIn: (logged_in === 'logged_in'),
      username,
    };

    return (
      <Header
        isCheckingUserStatus={logged_in === 'loading'}
        user={userFiltered}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.getUser && state.getUser.user,
  };
}

export default connect(
  mapStateToProps,
  { getUser }
)(HeaderContainer);
